import { render, staticRenderFns } from "./MiraSectionCard.vue?vue&type=template&id=180f5605&scoped=true&"
import script from "./MiraSectionCard.vue?vue&type=script&lang=ts&"
export * from "./MiraSectionCard.vue?vue&type=script&lang=ts&"
import style0 from "./MiraSectionCard.vue?vue&type=style&index=0&id=180f5605&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "180f5605",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VAvatar } from 'vuetify/lib/components/VAvatar';
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCard } from 'vuetify/lib/components/VCard';
import { VChip } from 'vuetify/lib/components/VChip';
import { VHover } from 'vuetify/lib/components/VHover';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VSpacer } from 'vuetify/lib/components/VGrid';
import { VTooltip } from 'vuetify/lib/components/VTooltip';
installComponents(component, {VAvatar,VBtn,VCard,VChip,VHover,VIcon,VSpacer,VTooltip})
